// OWNER: gifts module. Route objects relative to /w/:wsId, spread into the router by src/app/router.tsx.
// Pages are lazy-loaded so each feature is its own chunk. Add routes here; don't edit the router.
import type { RouteObject } from 'react-router';

const pages = () => import('./pages');

export const routes: RouteObject[] = [
  { path: 'money/gifts', lazy: async () => ({ Component: (await pages()).GiftsPage }) },
  { path: 'money/gifts/new', lazy: async () => ({ Component: (await pages()).GiftFormPage }) },
  { path: 'money/gifts/:giftId', lazy: async () => ({ Component: (await pages()).GiftDetailPage }) },
  { path: 'money/gifts/:giftId/edit', lazy: async () => ({ Component: (await pages()).GiftFormPage }) },
  { path: 'money/tax-years', lazy: async () => ({ Component: (await pages()).TaxYearsPage }) },
  { path: 'money/estate', lazy: async () => ({ Component: (await pages()).EstatePage }) },
  { path: 'records/deprivation', lazy: async () => ({ Component: (await pages()).DeprivationPage }) },
];
